import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClaimOrderModel } from '../../models/responseModels/ClaimOrderModel';
import { TranslateService } from '@ngx-translate/core';
import { InsuranceCase } from '../../../app-create-case/models/insurance-case.model';
import { CaseQueryService } from '../../../app-cases/services/case-query.service';
import { Subject, takeUntil } from 'rxjs';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { CaseCommonService } from '../../../app-create-case/services/case-common.service';
@Component({
    selector: 'app-audit-repair-connected-cases',
    templateUrl: './audit-repair-connected-cases.component.html',
    styleUrls: ['./audit-repair-connected-cases.component.scss'],
    standalone: false
})
export class AuditRepairConnectedCasesComponent implements OnInit {
    // lists
    @Input() duplicateClaimCaseList: ClaimOrderModel[] = [];
    @Input() data: any[] = [];

    // default
    @Input() bgColor: string = 'white';
    @Input() truncate: number = 45;

    // titles
    @Input() titleDisplay: any = {
        'InsuranceClaimNumber': null,
        'CaseStatus.Key': 'complex'
    };

    @Input() subTitleDisplay: any = {
        ZipCodeOfIssuer: null,
        InspectorUserName: null,
        OrderDate: 'date'
    };

    @Input() header: string = 'APP_CASES.DUPLICATION_CASE_LIST';

    // routing
    @Input() rootRoute: string = 'cases';

    // select deselect options
    @Input() selectedItemIds: string[];
    @Input() unSelectedItem: boolean = false;

    // source
    @Input() source: string = 'create-case';

    // special case details
    @Input() isDisconnectionButtonVisible: boolean = false;

    // toggling cases layout
    @Input() isFraudSectionVisible = true;

    // output variables
    @Output() outputForDuplicateCaseOrEmail = new EventEmitter<any>();
    @Output() outputForDisconnectButton = new EventEmitter<any>();
    @Output() retryUpdateDuplicateClaimCaseList = new EventEmitter<any>();

    // local variables
    destroy$: Subject<boolean> = new Subject<boolean>();
    allFraudCaseList: InsuranceCase[] = [];
    finalFraudCaseList: InsuranceCase[] = [];
    selectedFraudCaseItemIds: string[] = [];

    isRepairCaseTableSelected: boolean = false;
    @Input() isPendingRepairCaseConnection: boolean = false;
    @Input() isFailedRepairCaseConnection: boolean = false;
    @Input() isRetryRepairCaseConnection: boolean = false;

    constructor(
        private readonly translateService: TranslateService,
        private readonly caseQueryService: CaseQueryService,
        private readonly caseCommonService: CaseCommonService
    ) {}

    ngOnInit(): void {
        this.fraudCaseSubscription();
    }

    private fraudCaseSubscription(): void {
        this.caseQueryService.fraudCases$.pipe(takeUntil(this.destroy$)).subscribe(([fraudCases, action]) => {
            if (fraudCases.length === 0) {
                return;
            }

            if (action === SCConfig.FRAUD_CASE_ACTION.ADD) {
                this.finalFraudCaseList = this.finalFraudCaseList.concat(fraudCases);
                this.allFraudCaseList = this.allFraudCaseList.concat(fraudCases);
            } else if (action === SCConfig.FRAUD_CASE_ACTION.REMOVE) {
                // delete the fraud case from all fraud case list
                (fraudCases || []).forEach(fraudCase => {
                    this.deleteFraudCaseByItemId(fraudCase.ItemId);
                });

                // count the fraud cases by item id
                const fraudCasesCountByItemId = this.countFraudCasesByItemId(this.allFraudCaseList);

                // remove the fraud cases that are not present in the all fraud case list
                (fraudCases || []).forEach(fraudCase => {
                    if (fraudCasesCountByItemId.has(fraudCase.ItemId)) {
                        return;
                    }

                    // as this is not present in the all fraud case list,
                    // so we need to remove it from the final fraud case list
                    this.finalFraudCaseList = this.finalFraudCaseList.filter(x => x.ItemId !== fraudCase.ItemId);
                });
            }

            this.finalFraudCaseList = this.caseCommonService.getUniqueInsuranceCase(this.finalFraudCaseList);
            this.finalFraudCaseList = this.caseCommonService.sortInsuranceCaseByCreateDate(this.finalFraudCaseList);

            // selecting item ids for fraud case to show the item is selected
            this.selectedFraudCaseItemIds = this.finalFraudCaseList.map(item => item.ItemId);

            // merge fraud case
            this.onChangeFraudCase(this.selectedFraudCaseItemIds);
        });
    }

    private countFraudCasesByItemId(fraudCases: InsuranceCase[]): Map<string, number> {
        let fraudCaseCountMap = new Map<string, number>();
        (fraudCases || []).forEach(fraudCase => {
            if (fraudCaseCountMap.has(fraudCase.ItemId)) {
                fraudCaseCountMap.set(fraudCase.ItemId, fraudCaseCountMap.get(fraudCase.ItemId) + 1);
            } else {
                fraudCaseCountMap.set(fraudCase.ItemId, 1);
            }
        });
        return fraudCaseCountMap;
    }

    private deleteFraudCaseByItemId(itemId: string): void {
        const index = this.allFraudCaseList.findIndex(item => item.ItemId === itemId);

        if (index !== -1) {
            this.allFraudCaseList.splice(index, 1);
        }
    }

    public onChangeFraudCase(itemIds: string[]) {
        // these are selected fraud case ids
        this.caseQueryService.selectedFraudCaseItemIds$.next(itemIds);
    }

    // it works for case details page
    public onDisconnect(): void {
        this.outputForDisconnectButton.emit();
    }

    onTabChange(tabValue: string): void {
        if (tabValue === '0') {
            this.isRepairCaseTableSelected = false;
        } else if (tabValue === '1') {
            this.isRepairCaseTableSelected = true;
        } else if (tabValue === '2') {
            this.isRepairCaseTableSelected = false;
        }
    }
    onRetryRepairCaseConnection(): void {
        this.retryUpdateDuplicateClaimCaseList.emit({ action: 'retryRepairCaseConnection' });
    }
}
